import { __extends } from "tslib";
import React from 'react';
import PnmacUIButton from '../../Uibutton';
import PnmacHtmlToNative from '../../HtmlToNative';
import { View, Image } from 'react-native';
import BannerView from "../../v2/BannerView";
var InterstitialCompontent = /** @class */function (_super) {
  __extends(InterstitialCompontent, _super);
  function InterstitialCompontent(props) {
    return _super.call(this, props) || this;
  }
  InterstitialCompontent.prototype.render = function () {
    var _a = this.props,
      headerText = _a.headerText,
      goTo = _a.goTo,
      goBack = _a.goBack,
      bodyWarning = _a.bodyWarning,
      bodyNotes = _a.bodyNotes,
      BtnGoBackText = _a.BtnGoBackText,
      btnGoToText = _a.btnGoToText,
      loading = _a.loading,
      bodyToCancelText = _a.bodyToCancelText;
    return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
      style: {
        padding: 10,
        marginBottom: 5
      }
    }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
      value: headerText
    })), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(BannerView, {
      type: 'warning'
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start"
      }
    }, /*#__PURE__*/React.createElement(Image, {
      source: require("../../assets/warning.svg"),
      style: {
        width: 30,
        height: 30,
        marginEnd: 10
      }
    }), /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
      value: bodyWarning
    })), /*#__PURE__*/React.createElement(View, {
      style: {
        paddingStart: 20,
        paddingTop: 10,
        paddingEnd: 20
      }
    }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
      value: bodyNotes
    })))), /*#__PURE__*/React.createElement(View, {
      style: {
        paddingStart: 20,
        paddingEnd: 20,
        paddingTop: 10
      }
    }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
      value: bodyToCancelText
    })), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacUIButton, {
      mode: 'outlined',
      nativeID: "btnGoBack",
      style: {
        minWidth: "40%",
        marginTop: 50
      },
      onClick: function () {
        goBack();
      }
    }, BtnGoBackText)), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacUIButton, {
      mode: 'contained',
      nativeID: "btnGoTo",
      loading: loading,
      style: {
        minWidth: "40%",
        marginTop: 50
      },
      onClick: function () {
        goTo();
      }
    }, btnGoToText))));
  };
  return InterstitialCompontent;
}(React.Component);
export default InterstitialCompontent;